export class FormsMapValueToText {

    public static mapPpsValueToText(value: number, dataKey: string) {
        switch (dataKey) {
            case 'mobility':
                return this.mapPpsValueToMobility(value);
            case 'activity':
                return this.mapPpsValueToActivity(value);
            case 'illnessSymptoms':
                return this.mapPpsValueToIllnessSymptoms(value);
            case 'selfSufficiency':
                return this.mapPpsValueToSelfSufficiency(value);
            case 'foodIntake':
                return this.mapPpsValueToFoodIntake(value);
            case 'stateOfConsciousness':
                return this.mapPpsValueToStateOfConsciousness(value);
            default:
                return '';
        }
    }

    private static mapPpsValueToMobility(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'neomezená';
            case 90: return 'neomezená';
            case 80: return 'neomezená';
            case 70: return 'omezená';
            case 60: return 'omezená';
            case 50: return 'převážně leží nebo sedí';
            case 40: return 'převážně na lůžku';
            case 30: return 'trvale na lůžku';
            case 20: return 'trvale na lůžku';
            case 10: return 'trvale na lůžku';
            case 0: return 'smrt';
            default: return '';
        }
    }

    private static mapPpsValueToActivity(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'normální';
            case 90: return 'normální';
            case 80: return 'normální, vyžaduje úsilí';
            case 70: return 'neschopen zaměstnání/práce';
            case 60: return 'neschopen práce/činností doma';
            case 50: return 'neschopen žádné práce';
            case 40: return 'neschopen většiny činnosti';
            case 30: return 'neschopen žádné činnosti';
            case 20: return 'neschopen žádné činnosti';
            case 10: return 'neschopen žádné činnosti';
            case 0: return '−';
            default: return '';
        }
    }

    private static mapPpsValueToIllnessSymptoms(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'žádné';
            case 90: return 'mírné';
            case 80: return 'mírné';
            case 70: return 'významné';
            case 60: return 'významné';
            case 50: return 'plně rozvinutá choroba';
            case 40: return 'plně rozvinutá choroba';
            case 30: return 'plně rozvinutá choroba';
            case 20: return 'plně rozvinutá choroba';
            case 10: return 'plně rozvinutá choroba';
            case 0: return '-';
            default: return '';
        }
    }

    private static mapPpsValueToSelfSufficiency(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'plná';
            case 90: return 'plná';
            case 80: return 'plná';
            case 70: return 'plná';
            case 60: return 'příležitostná pomoc nutná';
            case 50: return 'častá pomoc nutná';
            case 40: return 'nutná pomoc s většinou činností';
            case 30: return 'úplná nesoběstačnost';
            case 20: return 'úplná nesoběstačnost';
            case 10: return 'úplná nesoběstačnost';
            case 0: return '-';
            default: return '';
        }
    }

    private static mapPpsValueToFoodIntake(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'normální';
            case 90: return 'normální';
            case 80: return 'normální nebo snížená';
            case 70: return 'normální nebo snížená';
            case 60: return 'normální nebo snížená';
            case 50: return 'normální nebo snížená';
            case 40: return 'normální nebo snížená';
            case 30: return 'snížená';
            case 20: return 'srkání tekutin';
            case 10: return 'jen zvlhčování úst';
            case 0: return '-';
            default: return '';
        }
    }

    private static mapPpsValueToStateOfConsciousness(ppsValue: number): string {
        switch(ppsValue) {
            case 100: return 'normální';
            case 90: return 'normální';
            case 80: return 'normální';
            case 70: return 'normální';
            case 60: return 'normální nebo zmatenost';
            case 50: return 'normální nebo zmatenost';
            case 40: return 'normální nebo spavost +/- zmatenost';
            case 30: return 'normální nebo spavost +/- zmatenost';
            case 20: return 'normální nebo spavost +/- zmatenost';
            case 10: return 'normální nebo spavost +/- zmatenost';
            case 0: return '-';
            default: return '';
        }
    }
}